import { Component, ComponentFactoryResolver, ComponentRef, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { PageViewComponent } from './page-view.component';
import { ClicksMonitorComponent } from '../monitoring/clicks/clicks-monitor.component';
import { Page } from '../admin/models/page.model';
import { PageViewService } from './page-view.service';
import { PagesTypes } from '../../../core/types/pages-types.enum';
import { ExportReportComponent } from '../export-report/export-report.component';

@Component({
  selector: 'kt-dynamic-page-view',
  template: '<ng-template></ng-template>',
})
export class DynamicPageViewComponent implements OnDestroy, OnInit {
  private components = {
    [PagesTypes.CUSTOM_PAGE]: PageViewComponent,
    [PagesTypes.CLICKS_MONITORING]: ClicksMonitorComponent,
    [PagesTypes.EXPORT_REPORT]: ExportReportComponent,
  };

  private unsubscribe$: Subject<any> = new Subject();
  private component: ComponentRef<any> = null;

  constructor(
    private route: ActivatedRoute,
    private service: PageViewService,
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
  ) {}

  ngOnInit() {
    this.route.paramMap
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((paramMap) =>
        this.service
          .getPageBySlug(paramMap.get('page'))
          .pipe(map(this.getPageTypeId), map(this.getComponentByIndex), takeUntil(this.unsubscribe$))
          .subscribe(this.createComponent),
      );
  }

  createComponent = (Component) => {
    if (this.component) this.component.destroy();
    this.viewContainerRef.clear();
    this.component = this.viewContainerRef.createComponent(this.resolver.resolveComponentFactory(Component));
    this.component.changeDetectorRef.reattach();
    this.component.changeDetectorRef.markForCheck();
    this.component.changeDetectorRef.detectChanges();
  };

  private getComponentByIndex = (index: number) => this.components[index];
  private getPageTypeId = (page: Page) => page.pageType.id;

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.component) this.component.destroy();
  }
}
